<template>
  <div>
    <div class="card">
      <div class="card-header">
        Avances de protocolo
      </div>
      <div class="card-body">
        <template v-if="loading">
          <div class="align-middle text-center py-2">
            <span class="spinner-border text-primary spinner-border-sm"
                  role="status"></span>
            Cargando información...
          </div>
        </template>
        <template v-if="!loading && error">
          <div class="align-middle text-center py-2">
            <div class="alert alert-info has-icon d-none align-items-center d-flex mb-0" role="alert">
              <div class="alert-icon">
                <span class="oi oi-info"></span>
              </div>
              {{ errorMessagge }}
            </div>
          </div>
        </template>
        <template v-if="!loading && !error">
          <dynamic-table :columns="committeeDictumsColumns"
                        :data="protocolTaskAdvance"
                        :loading="loading"
                        class="table-hover"
                        empty-message="No existen avances registrados.">
            <template v-slot:file_path="slotProps">
              <a
                :href="`${slotProps.row.file_path}`"
                download=""
                class="text-truncate d-block"
                style="max-width: 300px"
                :title="slotProps.row.file_name"
                >{{ slotProps.row.file_name }}</a
              >
            </template>
          </dynamic-table>

        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicTable from '../../ui/DynamicTable'
  import { mapActions, mapGetters } from 'vuex'
  
  export default {
    name: 'PreviousStageReport',
    components: {
      DynamicTable,
    },
    data() {
      return {
        loading: true,
        error: false,
        errorMessagge: '',
        committeeDictumsColumns: [
          {
            field: 'id',
            title: 'No.',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'comments',
            title: 'Comentarios',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'file_path',
            title: 'Documento',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
        ],
      }
    },
    props: {
      protocol: Object,
      committee: Object,
      task: Object,
    },
    computed: {
      ...mapGetters({
        protocolTaskAdvance: 'committees/protocolTaskAdvance',
      }),
    },
    methods: {
      ...mapActions({
        getProtocolTaskAdvance: 'committees/getProtocolTaskAdvance',
      }),
      
      async load() {
        this.loading = true
        
        const response = await this.getProtocolTaskAdvance({
          protocol: this.protocol.id,
          committee: this.committee.id,
        })
        
        if (response.status === 'error') {
          this.errorMessagge = response.error

          this.error = true
        }
        
        this.loading = false
      },
    },
    async mounted() {
      await this.load()
    },
  }
</script>
